import { useReducer } from "react";
import { produce } from 'immer';

export type StateFn<S> = (state: S) => S;

export function useFnReducer<S>(initState: S) {
  const FnReducer = (state: S, afn: StateFn<S>) => afn(state);
  return useReducer(FnReducer, initState);
}
export type ChangeDispatch<S> = (changeFn: (darft: S) => void) => void

export type ProduceHook = typeof useProduce;
export type ProduceStore<S> = [S, ChangeDispatch<S>]
export function useProduce<S>(initState: S): [S, ChangeDispatch<S>] {
  const [state, _dispatch] = useFnReducer(initState);
  const dispatch = (changeFn: (darft: S) => void) => _dispatch((state: S) => produce(state, changeFn));
  return [state, dispatch];
}

export type SetDispatch<S> = {
  [k in keyof S]: (value: S[k]) => void
};

export type SetterStore<S> = { get: S, set: SetDispatch<S> };
export function useSetter<S>(initState: S): SetterStore<S> {
  const [get, _dispatch] = useProduce(initState);
  const set: SetDispatch<S> =
    new Proxy({}, {
      get(_, p) {
        return (value: any) => {
          _dispatch(darft => {
            darft[p] = value
          });
        };
      }
    }) as SetDispatch<S>;
  return {
    get,
    set,
  };
}